



















































































































import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { mixins } from 'vue-class-component'
import { Constant } from '@/_services/constant'

// Mixins
import BeaconListMixin from '@/components/mixins/BeaconListMixin.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

// Models
import BeaconModel from '@/_models/BeaconModel'

// Interfaces
import { IDropdownList } from '@/_interfaces'

// Helpers
import { Filter } from '@/_utils/filter'
import { BEACON_CARRIED_FIELD } from '@/_consts/CSVFields'

// Components
import NotFound from '@/components/common/NotFound.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'
import ActionButtonsGroup from '@/components/common/buttons/ActionButtonsGroup.vue'
import SearchUser from '@/components/shared/SearchUser.vue'
import TablePagination from '@/components/shared/TablePagination.vue'
import BeaconCarriedListEditModal from './modals/BeaconCarriedListEditModal.vue'
import ImportCSVModalLayout from '@/components/common/modals/ImportCSVModalLayout.vue'

@Component({
  components: {
    SearchUser,
    NotFound,
    TablePagination,
    DropdownSearch,
    ActionButtonsGroup,
    BeaconCarriedListEditModal,
    ImportCSVModalLayout,
  },
  computed: {
    ...mapGetters('beacons', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('beacons', {
      canDelete: 'canDelete',
    }),
  },
})
export default class BeaconCarriedList extends mixins(BeaconListMixin, TableSortMixin) {
  filterUtilTableSort: any = new Filter('filter_beacon_carried_table_sort')
  // data
  beaconType: string = Constant.BEACON_TYPE_CARRIED
  filterUtilPage: any = new Filter('filter_beacon_carried_list_page')
  selected: BeaconModel = new BeaconModel(Constant.BEACON_TYPE_CARRIED)

  dropdownList: IDropdownList[] = [
    {
      value: 'beacon_uuid',
      label: '',
    },
    {
      value: 'major',
      label: 'Major',
    },
    {
      value: 'minor',
      label: 'Minor',
    },
  ]

  get exportCSVName(): string {
    return 'beacons_carried.csv'
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new BeaconModel(this.beaconType)
    this.isNew = true
  }

  // Overide BeaconListMixin mixin
  getAllBeacons() {
    this.$store.dispatch('beacons/getAll', {
      beacon_type: Constant.BEACON_TYPE_CARRIED,
    })
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.csvFields = BEACON_CARRIED_FIELD
    this.dropdownList[0].label = this.labelBeaconUUID
  }
}
